import { Injectable } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { BodyBlock } from '../../shared/body-block';

@Injectable()
export class BlockUIService {
  @BlockUI()
  blockUI!: NgBlockUI;

  constructor(private bodyBlock: BodyBlock) { }

  BlockUIAngular(): void {
      this.blockUI.start('Loading...');
      this.bodyBlock.blockBody();
  }
  UnBlockUIAngular(): void {
      this.blockUI.stop();
      this.bodyBlock.unblockBody();
  }
}
